import { DetailsListLayoutMode } from "@fluentui/react/lib/DetailsList";
import { Selection } from "@fluentui/react/lib/Selection";
import { ShimmeredDetailsList } from '@fluentui/react/lib/ShimmeredDetailsList';
import React from "react";
import { EmptyColumn } from "../defaults";
import { Guid, isNullOrEmpty } from "../utilities";
import { Column } from './Column';
import { Grid } from "./Grid";
import { Row } from './Row';
export class XDataTable extends React.Component {
    constructor(props) {
        super(props);
        this._sortDirection = {};
        this._selection = new Selection({
            onSelectionChanged: () => {
                if (this.props.onSelectionChanged) {
                    this.props.onSelectionChanged(this._selection.getSelection());
                }
            }
        });
        this.state = {
            columns: this.mapColumns(props.columns || []),
            isLoading: false,
            items: props.items || [],
            lastItem: 0,
            recordsFiltered: 0,
            selectionMode: props.selectionMode,
            request: props.request
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            request: props.request,
            items: props.items || [],
            columns: this.mapColumns(props.columns || [])
        });
    }
    mapColumns(columns) {
        return [
            ...columns.map(x => ({
                key: isNullOrEmpty(x.name) ? Guid.newGuid().toString() : x.name,
                name: x.name,
                minWidth: x.minWidth,
                maxWidth: x.maxWidth || x.minWidth + 20,
                onRender: (item) => x.onRender(item),
                isResizable: x.isResizable,
                isSorted: x.isSorted,
                isSortedDescending: x.isSortedDescending,
                onColumnClick: () => {
                    const columns = this.state.columns.slice();
                    const index = columns.findIndex(o => o.key === x.name);
                    this._sortDirection[index] = columns[index].isSortedDescending = !this._sortDirection[index];
                    columns.map(x => x.isSorted = false);
                    columns[index].isSorted = true;
                    columns.filter(o => o.key !== columns[index].key).forEach(o => o.isSorted = false);
                    this.setState({
                        columns,
                        request: Object.assign(Object.assign({}, this.state.request), { orderColumn: this.state.columns.findIndex(o => o.key === x.name), sortDirection: columns[index].isSortedDescending ? 'desc' : 'asc' })
                    }, () => {
                        this.props.onDownloadServerData(this.state.request);
                    });
                },
            })),
            EmptyColumn
        ];
    }
    render() {
        return React.createElement(Grid, null,
            React.createElement(Row, null,
                React.createElement(Column, { size: 12 },
                    React.createElement(ShimmeredDetailsList, { items: this.state.items, columns: this.state.columns, selectionMode: this.state.selectionMode, layoutMode: DetailsListLayoutMode.fixedColumns, isHeaderVisible: true, enableShimmer: this.state.isLoading, selectionPreservedOnEmptyClick: true, selection: this._selection, shimmerLines: this.state.items.length || this.state.request.length, detailsListStyles: {
                            root: {
                                overflow: 'initial'
                            }
                        }, getKey: x => String(this.props.onGetKey(x)) }))));
    }
}
